import React from 'react';
import { ButtonClean, Icon } from '@fourthwall/components';
import { NewWindowIcon } from '@fourthwall/icons';
import GoogleAnalyticsIcon from '../../assets/google-analytics-icon.svg';
import * as S from './styled';
export const GoogleAnalyticsReportBottomContent = ({ href, }) => {
    return (React.createElement(S.Container, null,
        React.createElement(S.Icon, null,
            React.createElement("img", { src: GoogleAnalyticsIcon, alt: "Google Analytics Logo" })),
        "This data comes from Google Analytics and is gathered from the moment you added the integration.",
        ` `,
        href && (React.createElement(ButtonClean, { appearance: "secondary", label: React.createElement(S.Label, null,
                "View in Google Analytics",
                React.createElement(Icon, { component: NewWindowIcon, height: 10 })), href: href, target: "_blank" }))));
};
